export const SET_LOGGING_SERVICE = 'SET_LOGGING_SERVICE';
